import { createSelector } from "reselect";
import { maritalStatus as maritalStatusConfig } from "config/config";

const profileState = (state) => state.profile;

const getProfile = createSelector(profileState, (profile) => profile);
const getCounter = createSelector(profileState, (profile) => profile.counter);
const getPersonalInfo = createSelector(
  profileState,
  (profile) => profile.personalInfo
);
const getRasiKatam = createSelector(
  profileState,
  (profile) => profile.rasiKatam
);
const getRasiPlanets = createSelector(
  profileState,
  (profile) => profile.rasiPlanets
);
const getNavamsaKatam = createSelector(
  profileState,
  (profile) => profile.navamsaKatam
);
const getNavamsaPlanets = createSelector(
  profileState,
  (profile) => profile.navamsaPlanets
);
const getSkipRasi = createSelector(profileState, (profile) => profile.skipRasi);
const getSkipNavamsa = createSelector(
  profileState,
  (profile) => profile.skipNavamsa
);
const getResidentialDetails = createSelector(
  profileState,
  (profile) => profile.residentialAddress
);
const getContactNumber = createSelector(
  profileState,
  (profile) => profile.contactDetails
);
const getQualification = createSelector(
  profileState,
  (profile) => profile.qualification
);
const getOccupation = createSelector(
  profileState,
  (profile) => profile.occupation
);
const getHoroscopeDetails = createSelector(
  profileState,
  (profile) => profile.horoscopeDetails
);
const getFamilyDetails = createSelector(
  profileState,
  (profile) => profile.familyDetails
);
const getBirthDetails = createSelector(
  profileState,
  (profile) => profile.birthDetails
);
const getProfileImage = createSelector(
  profileState,
  (profile) => profile.personalInfo.profileImage
);
const getEditedProfileImage = createSelector(
  profileState,
  (profile) =>
    profile.personalInfo.editedUrl || profile.personalInfo.profileImage
);
const getIsFormChanged = createSelector(
  profileState,
  (profile) => profile.isFormChanged
);

const getGovtId = createSelector(profileState, (profile) => profile.govtId);
const getEditedGovtId = createSelector(
  profileState,
  (profile) => profile.editedGovtId || profile.govtId
);
// const getProfileStatus = createSelector(
//   profileState,
//   (profile) => profile.profileStatus
// );
const getOtherDetails = createSelector(profileState, (profile) => {
  return {
    profileImage: profile.personalInfo.profileImage,
    editedUrl:
      profile.personalInfo.editedUrl || profile.personalInfo.profileImage,
    fatherOccupation: profile.familyDetails.fatherOccupation,
    motherOccupation: profile.familyDetails.motherOccupation,
    familyStatus: profile.familyDetails.familyStatus,
    caste: profile.familyDetails.caste,
    religion: profile.familyDetails.religion,
    companyName: profile.occupation.companyName,
    cityOfWorking: profile.occupation.cityOfWorking,
    fieldOfStudy: profile.qualification[0]?.fieldOfStudy || "",
    hometown: profile.residentialAddress.hometown,
    lookingFor: profile.lookingFor,
    createdBy: profile.createdBy,
    ownHouse: profile.ownHouse,
    startDate: profile.startDate,
    fatherAlive: profile.familyDetails.fatherAlive,
    motherAlive: profile.familyDetails.motherAlive,
    horoscopeImage: profile.horoscopeImage,
    editedHoroscopeImage:
      profile.editedHoroscopeImage || profile.horoscopeImage,
    eatingHabits: profile.eatingHabits,
    smokingHabits: profile.smokingHabits,
    drinkingHabits: profile.drinkingHabits,
    propertyDetails: profile.propertyDetails,
    otherIncome: profile.otherIncome,
    hobbies: profile.personalInfo.hobbies,
    aboutMyFamily: profile.personalInfo.aboutMyFamily,
    bodyType: profile.personalInfo.bodyType,
    eyeWear: profile.personalInfo.eyeWear,
  };
});

const getVerificationDetails = createSelector(profileState, (profile) =>
  profile?.verificationDetails ? profile.verificationDetails : {}
);

const getMaritalStatus = createSelector(
  profileState,
  (profile) => profile.personalInfo.maritalStatus
);

const getIsSecondMarriage = createSelector(
  getMaritalStatus,
  (maritalStatus) =>
    maritalStatus &&
    maritalStatus.toLowerCase() !== "select" &&
    maritalStatus !== maritalStatusConfig[0].value &&
    maritalStatus !== maritalStatusConfig[1].value
);

// Dosham fields and their display labels
const DOSHAM_LABELS = {
  chevaiDosham: "Sevvai Dosham",
  raguDosham: "Rahu-Kethu Dosham",
  kalathiraDosham: "Kalathira Dosham",
  mangalyaDosham: "Mangalya Dosham",
  pithruDosham: "Pithru Dosham",
  suryaDosham: "Surya Dosham",
};

// Returns a comma-joined string of active doshams (skips "No" and "Unknown")
const getDoshamDetails = createSelector(
  getHoroscopeDetails,
  (horoscopeDetails) => {
    if (!horoscopeDetails) return "";
    const activeDoshams = Object.entries(DOSHAM_LABELS)
      .filter(([key]) => {
        const val = horoscopeDetails[key];
        if (!val) return false;
        const normalized = String(val).trim().toLowerCase();
        return (
          normalized !== "no" &&
          normalized !== "unknown" &&
          normalized !== "select"
        );
      })
      .map(([, label]) => label);
    return activeDoshams.join(", ");
  }
);

export {
  getBirthDetails,
  getContactNumber,
  getCounter,
  getDoshamDetails,
  getFamilyDetails,
  getGovtId,
  getEditedGovtId,
  getHoroscopeDetails,
  getIsFormChanged,
  getNavamsaKatam,
  getNavamsaPlanets,
  getSkipRasi,
  getSkipNavamsa,
  getOccupation,
  getOtherDetails,
  getPersonalInfo,
  getProfile,
  getProfileImage,
  getEditedProfileImage,
  // getProfileStatus,
  getQualification,
  getRasiKatam,
  getRasiPlanets,
  getResidentialDetails,
  getVerificationDetails,
  getMaritalStatus,
  getIsSecondMarriage,
};
